import { PurchaseLoggerContext } from '@bees-web/core/shared'
import { useMemo, useCallback } from 'react'

export const PurchaseLoggerProvider = ({ children }) => {
  const logPurchase = useCallback(
    ({ productId, price, currency, quantity = 1, customAttributes }) => {
      console.info('[Braze Provider] Initialized')
      if (window.braze) {
        window.braze.logPurchase(productId, price, currency, quantity, customAttributes)
      } else {
        console.warn('Braze SDK not initialized')
      }
    },
    []
  )

  const value = useMemo(
    () => ({ onInitialize: () => console.info('Initialized'), logPurchase }),
    [logPurchase]
  )

  return (
    <PurchaseLoggerContext.Provider value={value}>
      {children}
    </PurchaseLoggerContext.Provider>
  )
}

export default PurchaseLoggerProvider
